<template>
<m-pageframe
    title="Create Organization"
>

<v-container
    fluid
    style="padding: 15px; padding-left: 30px; padding-right: 30px;"
>
    <b>Organization Settings</b>

    <div
        style="margin-left: 30px"
    >
        <v-text-field
            label = "Organization Name"
            v-model="profile.organization_account.label"
            ref="organization_name"
            autocomplete="off"
        />

        <m-edit-select-enum
            label="Industry"
            v-model="profile.organization_account.industry"
            enum_name="industry_code"
            dialog_title="Select industry"
            :allow_any_enum_value="false"
        />

        <v-select
            label="Register new phone numbers with"
            v-model="profile.organization_account.register_new_phone_numbers_with"
            :items="$rc.enumChoices('comm_network',false)"
            disabled
        />

        <v-select
            label="Primary Time Zone"
            :items="$rc.commonTimeZones()"
            v-model="profile.organization_account.primary_timezone"
            v-on:change="onChangeOrgTimezone"
        />

        <m-autocomplete-country-and-subdivision
            v-model="profile.organization_account.country_and_subdivision"
        />

        <v-checkbox
            style="margin-top: -5px"
            label="Archived"
            v-model="profile.organization_account.is_archived"
        />

        <v-checkbox
            style="margin-top: -15px"
            label="Non-Revenue"
            :value="!profile.organization_account.is_revenue_account"
            v-on:change="onChangeNonRevenue"
        />

        <v-checkbox
            style="margin-top: -15px"
            label="RedChirp Promotion Prohibited"
            v-model="profile.organization_account.red_chirp_promotion_prohibited"
        />

        <v-checkbox
            style="margin-top: -15px"
            label="Sandbox Account"
            v-model="profile.organization_account.is_sandbox_organization"
            v-on:click="onClickSandboxAccount"
        />

        <m-edit-tags
            label="Organization Origin (a.k.a. Promos)"
            applies_to="organization-origin"
            v-model="profile.organization_account.rc_tag_ids"
        />
    </div>

    <b>First Organization Administrator</b>
    <div
        style="margin-left: 30px"
    >
        <v-text-field
            label="Username (email address)"
            v-model="profile.new_employee_account.username"
            v-on:input="checkUsername"
        />

        <p
            style="font-weight: bold; color: red"
        >
            {{username_used_in_other_orgs_pretty}}
        </p>

        <v-text-field
            label="First Name"
            v-model="profile.new_employee_account.first_name"
            v-if="!user_already_exists"
        />

        <v-text-field
            label="Last Name"
            v-model="profile.new_employee_account.last_name"
            v-if="!user_already_exists"
        />

        <v-text-field
            label="Personal Cell Phone Number (optional)"
            v-model="profile.new_employee_account.personal_cell"
            v-if="!user_already_exists"
        />

        <v-select
            label="Timezone"
            :items="$rc.commonTimeZones()"
            v-model="profile.new_employee_account.time_zone"
            v-if="!user_already_exists"
        />

        <v-select
            label="Account Type"
            :value="profile.new_employee_account.account_type"
            :items="choices_account_type"
            disabled
            v-if="!user_already_exists"
        />
    </div>

    <v-alert
        v-model="show_alert"
        color="primary"
        type="error"
        dismissible
    >
        {{alert_text}}
    </v-alert>

    <v-btn
        color="primary"
        v-on:click="createNewOrganization"
    >
        Create New Organization
    </v-btn>



    <m-admin-organization-auto-action-dialog
        ref="auto-action-dailog"
        v-on:create-org="onCreateOrgWithAutoAction"
    />

</v-container>
</m-pageframe>
</template>

<script>
const TestData = require("@/js/TestData.js");
const _ = require('lodash');
const Validation = require('@/js/validate.js');

export default {
    data() {
        return {
            profile: this.createDefaultProfile(),

            choices_account_type: [
                { 'text' : 'Organization Administrator', 'value' : 'org-admin' },
                { 'text' : 'Ordinary User', 'value' : 'ordinary-user' },
            ],

            username_used_in_other_orgs: [],

            show_alert: false,
            alert_text: null,
        }
    },
    mounted () {
        this.reloadProfile();
    },

    methods: {
        reloadProfile()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/red-chirp-crm/organizations/admin-summary/:organization_id',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                    
                    if ( !data.is_prospective_organization )
                    {
                        this.$router.push({
                            'name': 'settings-organization',
                            'params' : {
                                'organization_id': this.$route.params.organization_id,
                            },
                            'query': {
                                'open_panel': 2,
                            },
                        });
                    }

                    this.profile.organization_account.label = data.label;
                    this.profile.organization_account.industry = data.industry;
                    this.profile.organization_account.primary_timezone = data.primary_timezone;
                    this.profile.organization_account.is_archived = data.is_archived;
                    this.profile.organization_account.is_revenue_account = data.is_revenue_account;
                    this.profile.organization_account.red_chirp_promotion_prohibited = data.red_chirp_promotion_prohibited;
                    this.profile.organization_account.rc_tag_ids = data.rc_tag_ids;

                    if ( data.country_and_subdivision != null )
                        this.profile.organization_account.country_and_subdivision = data.country_and_subdivision;
                },
            
                'on_error': () => {
                    this.profile.organization_account.industry = 'wine';

                    window.setTimeout(
                        () => {this.$refs['organization_name'].focus();},
                        250,
                    );
                    
                },
            });
        },

        createDefaultProfile()
        {
            return {
                'organization_account': {
                    'organization_id' : this.$route.params.organization_id,
                    'industry' : 'uncategorized',
                    'label' : '',
                    'primary_timezone' : 'America/Phoenix',
                    'country_and_subdivision' : 'US-AZ',
                    'inboxes' : 'create_default',
                    'inbox_urls' : 'create_default',
                    'groups' : 'create_default',
                    'creation_date' : new Date().toISOString().substring(0,10),
                    'is_revenue_account' : true,
                    'is_archived': false,
                    'organization_state': 'pre-launch',
                    'features' : {
                    },
                    'register_new_phone_numbers_with': 'bandwidth',
                },
                'new_employee_account': {
                        'username': null,
                        'first_name': null,
                        'last_name' : null,
                        'personal_cell': null,
                        'time_zone' : 'America/Phoenix',
                        'account_type': 'org-admin',
                    },
            };
        },

        onClickSandboxAccount()
        {
            if ( this.profile.organization_account.is_sandbox_organization )
            {
                this.profile.organization_account.is_revenue_account = false;
                this.profile.organization_account.register_new_phone_numbers_with = 'sand-comm';
            }
            else
            {
                this.profile.organization_account.is_revenue_account = true;
                this.profile.organization_account.register_new_phone_numbers_with = 'bandwidth';
            }
        },

        onChangeOrgTimezone()
        {
            this.profile.new_employee_account.time_zone = this.profile.organization_account.primary_timezone;
        },

        isValidGeneral()
        {
            if ( this.profile.organization_account.label.trim().length == 0 )
                return false;

            if ( this.profile.organization_account.industry == 'uncategorized' )
                return false;

            if ( this.profile.new_employee_account.username == null )
                return false;

            if ( !Validation.isEmailAddress(this.profile.new_employee_account.username) )
                return false;

            if ( !this.user_already_exists )
            {
                if ( Validation.isBlank(this.profile.new_employee_account.first_name) )
                    return false;

                if ( Validation.isBlank(this.profile.new_employee_account.last_name) )
                    return false;

                if ( this.profile.new_employee_account.time_zone == null )
                    return false;

                if ( !Validation.isBlankOrUSPhoneNumber(this.profile.new_employee_account.personal_cell) )
                    return false;
            }

            return true;
        },

        createNewOrganization()
        {
            if ( this.profile.organization_account.label.trim().length == 0 )
            {
                this.show_alert = true;
                this.alert_text = 'The organization name can not be blank';
                return;
            }

            if ( this.profile.organization_account.industry == 'uncategorized' )
            {
                this.show_alert = true;
                this.alert_text = 'The industry must be set';
                return;
            }

            if ( this.profile.new_employee_account.username == null )
            {
                this.show_alert = true;
                this.alert_text = 'The first organization administrator username may not be blank';
                return;
            }

            if ( !Validation.isEmailAddress(this.profile.new_employee_account.username) )
            {
                this.show_alert = true;
                this.alert_text = 'The first organization administrator username must be a valid email address';
                return;
            }

            if ( !this.user_already_exists )
            {
                if ( Validation.isBlank(this.profile.new_employee_account.first_name) )
                {
                    this.show_alert = true;
                    this.alert_text = 'The first organization administrator first name may not be blank';
                    return;
                }

                if ( Validation.isBlank(this.profile.new_employee_account.last_name) )
                {
                    this.show_alert = true;
                    this.alert_text = 'The first organization administrator last name may not be blank';
                    return;
                }

                if ( this.profile.new_employee_account.time_zone == null )
                {
                    this.show_alert = true;
                    this.alert_text = 'The first organization administrator must have a time zone selected';
                    return;
                }

                if ( !Validation.isBlankOrUSPhoneNumber(this.profile.new_employee_account.personal_cell) )
                {
                    this.show_alert = true;
                    this.alert_text = 'The first organization administrator personal cell phone is not a valid phone number';
                    return;
                }
            }

            this.$refs['auto-action-dailog'].showDialog(this.profile.organization_account);
        },

        onCreateOrgWithAutoAction(selected_auto_actions)
        {
            let post_data = this.profile.organization_account;
            post_data['auto_actions'] = selected_auto_actions;
            post_data['new_employee_account'] = this.profile.new_employee_account;


            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/organizations/organization-account',
            
                'params' : post_data,
            
                'on_success': (data) => {
                        this.$rc.newSignInAs({
                            'organization_id': this.$route.params.organization_id,
                            'employee_id': 'any-org-admin', 
                            'after_route': {
                                'name': 'provision',
                                'params' : {
                                    'organization_id': this.$route.params.organization_id,
                                },
                            },
                        });
                    },
            
                'on_error': 'Unable to update organization',
            });
        },

        onChangeNonRevenue(value)
        {
            this.profile.organization_account.is_revenue_account = !value;
        },

        checkUsername: _.debounce(function(){
            this.doCheckUsername();
        }, 751),
        
        doCheckUsername()
        {
            
            this.$rc.rest(
                'LIST: /api/v1/list-orgs-with-username',
            
                {
                    'username': this.profile.new_employee_account.username,
                },
            
                (data) => {
                    this.username_used_in_other_orgs =  data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },
    },

    computed: {
        username_used_in_other_orgs_pretty()
        {
            if ( this.username_used_in_other_orgs.length == 0 ) 
                return null;

            let label = this.profile.organization_account.label;
            if ( label == '' ) label = null;  

            return this.profile.new_employee_account.username + ' is also a user in '+this.$rc.pretty(this.username_used_in_other_orgs,'comma_and_list')+'.  They will be added as an organization administrator of '+(label ?? 'the new organization you are creating');
        },

        user_already_exists()
        {
            return this.username_used_in_other_orgs.length > 0;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>